module.exports = __webpack_public_path__ + "static/media/back-arrow-grey-40x40.4c5cccb7.svg";